// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1w2iT","rootNoMargin":"styles_rootNoMargin__pt8cI"};